import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 静态文件列表
const STATIC_FILES = ['/sitemap.xml', '/robots.txt', '/favicon.ico', '/manifest.json'];

// ���果是静态文件请求，不渲染React应用
if (STATIC_FILES.includes(window.location.pathname)) {
  // 让服务器提供静态文件
  console.log('Static file requested:', window.location.pathname);
  // 不渲染React应用
} else {
  // 渲染React应用
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}